module.exports = __webpack_public_path__ + "img/IMG_0079_L_Wood_MockedUp.d925f542.jpg";